module.exports = __webpack_public_path__ + "img/fastcharger-in-progress-semipublic.acf76975.png";